import _ from 'lodash';
import Badge from 'react-bootstrap/Badge';
import { Pill } from '@janus.team/janus-particles';
import { useProductModelContext } from 'customer/product-model-context';
import { serviceLevelLabel, getServiceBlockName } from '../utils';

export const ServiceLevel = ({ project }) => {
  const { products } = useProductModelContext();
  if (_.isEmpty(products)) return null;
  const projectServiceBlockBadges = _.some(project?.serviceBlocks) ? (
    _.map(project?.serviceBlocks, (serviceBlock) => (
      <Pill key={serviceBlock?.serviceBlockId} color="none" filled={false} square>
        {getServiceBlockName(products, serviceBlock?.serviceBlockId)}
      </Pill>
    ))
  ) : (
    <Pill key="0" color="none" filled={false} square>
      No services assigned
    </Pill>
  );

  return (
    <>
      {(/service_blocks/i).test(project?.serviceLevel) ? projectServiceBlockBadges : (
        <Pill key={project?.serviceLevel} color="none" filled={false} square>
          {serviceLevelLabel(project?.serviceLevel)}
        </Pill>
      )}
    </>
  );
};

export default ServiceLevel;
